import Toggle from 'react-toggle'
import './toggle-boolean.css'
import { ChangeEventHandler, useCallback } from 'react'

interface IToggleBooleanProps {
  onClick: (value: boolean) => void
  className?: string
  isChecked: boolean
}

const ToggleBoolean = ({ onClick, isChecked }: IToggleBooleanProps): JSX.Element => {
  const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback(
    (e) => {
      onClick(e.target.checked)
    },
    [onClick]
  )

  return <Toggle defaultChecked={isChecked} icons={false} onChange={handleChange} />
}

export { ToggleBoolean }
